import React from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const { id } = useParams();
  return (
    <main className="max-w-2xl mx-auto px-4 py-20 text-center">
      <CheckCircle2 size={64} className="mx-auto text-emerald-500 mb-4"/>
      <h1 className="font-display text-3xl font-bold mb-2">Order placed successfully!</h1>
      <p className="text-slate-600 mb-2">Your order ID: <span className="font-mono font-semibold">{id}</span></p>
      <p className="text-slate-500 text-sm">We've sent a confirmation. Track your order in My Orders.</p>
      <div className="flex gap-3 justify-center mt-6">
        <Link data-testid="success-track-btn" to={`/account/orders/${id}`} className="btn-primary-sf px-6 py-2.5 rounded-full text-sm font-semibold">Track Order</Link>
        <Link data-testid="success-shop-btn" to="/products" className="border border-slate-200 px-6 py-2.5 rounded-full text-sm font-semibold">Continue Shopping</Link>
      </div>
    </main>
  );
}
